import React from 'react';

const CustomSwitchV2 = ({
  checked,
  onChange,
  color = 'blue',
  disabled = false,
  label = null,
  showText = false,
}) => {
  // Color configurations
  const colorConfig = {
    green: {
      on: 'bg-green-500 border-green-500',
      off: 'bg-gray-300 border-gray-300',
      circle: 'bg-white',
    },
    blue: {
      on: 'bg-primary-blue-dark border-primary-blue-dark',
      off: 'bg-gray-300 border-gray-300',
      circle: 'bg-white',
    },
    red: {
      on: 'bg-error border-error',
      off: 'bg-gray-300 border-gray-300',
      circle: 'bg-white',
    },
  };

  const currentColor = colorConfig[color];

  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <div className="flex items-center space-x-3">
      {label && (
        <label className="text-sm font-medium text-gray-700 select-none">
          {label}
        </label>
      )}

      <div
        className={`
          relative inline-flex items-center
          ${checked ? currentColor.on : currentColor.off}
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
          border-2 transition-all duration-300 ease-in-out
         
          transform hover:scale-105 active:scale-95
        `}
        style={{
          width: '36px',
          height: '20px',
          borderRadius: '100px',
        }}
        onClick={handleClick}>
        {/* Switch Circle */}
        <div
          className={`
            ${currentColor.circle}
            transition-all duration-300 ease-in-out
            transform ${checked ? 'translate-x-4' : 'translate-x-0.5'}
          
            absolute
          `}
          style={{
            width: '16px',
            height: '16px',
            borderRadius: '50%',
          }}
        />

        {/* Switch Text */}
        {showText && (
          <span
            className={`
              absolute inset-0 flex items-center justify-center
              text-xs font-semibold transition-all duration-300
              ${checked ? 'text-white' : 'text-gray-500'}
              pointer-events-none select-none
            `}>
            {checked ? 'ON' : 'OFF'}
          </span>
        )}
      </div>
    </div>
  );
};

export default CustomSwitchV2;
